export default function InventoryFormSection({ children, title }) {
    return (
        <div className="mb-3">
            <h4>{title}</h4>
            <hr />
            {children}
        </div>
    )
}